export type WarehouseKind = "branch" | "cargo_branch" | "parcel_locker" | "other";
export type SupportedLocale = "uk" | "en";
export const NOVA_POSHTA_REFERENCE_DATA_V1_FLAG = "NOVA_POSHTA_REFERENCE_DATA_V1";

export interface NovaPoshtaSettlementOption {
  settlementRef: string;
  label: string;
  region: string | null;
}

export interface NovaPoshtaWarehouseOption {
  warehouseRef: string;
  settlementRef: string;
  kind: WarehouseKind;
  label: string;
  shortAddress: string;
  number: string | null;
  maxWeightKg: number | null;
  isActive: boolean;
}

export interface NovaPoshtaReferenceSelection {
  mode: "warehouse" | "parcel_locker" | "address";
  settlementRef: string;
  /** Explicit CityRef when provider distinguishes it (usually same as settlementRef). */
  cityRef?: string;
  settlementLabel: string;
  settlementType?: string | null;
  region?: string | null;
  area?: string | null;
  warehouseRef?: string;
  warehouseLabel?: string;
  /** Branch / postomat number when known from directory. */
  warehouseNumber?: string | null;
  warehouseAddress?: string | null;
  streetRef?: string;
  building?: string;
  flat?: string;
  /** Prepared address line (117A — not full live street API) */
  addressLine?: string;
  locale: SupportedLocale;
  /** Persisted in checkout session / profile when flag enabled */
  version: "117A-v1";
}

export interface NovaPoshtaReferenceSearchResponse {
  ok: true;
  items: NovaPoshtaSettlementOption[] | NovaPoshtaWarehouseOption[];
  correlationId: string;
  mode: "fixture" | "live_readonly";
}

export interface NovaPoshtaReferenceValidationError {
  code: string;
  field?: string;
  message: string;
}

export interface NovaPoshtaReferenceValidateResponse {
  ok: boolean;
  errors: NovaPoshtaReferenceValidationError[];
  normalized?: {
    settlementRef: string;
    warehouseRef?: string;
    mode: NovaPoshtaReferenceSelection["mode"];
  };
}

/** API paths (workers-api `/api/shipping/reference/*`) */
export const NP_REFERENCE_API = {
  searchSettlements: "/api/shipping/reference/settlements/search",
  listWarehouses: "/api/shipping/reference/warehouses",
  warehouseByRef: (ref: string) => `/api/shipping/reference/warehouses/${encodeURIComponent(ref)}`,
  warehouseTypes: "/api/shipping/reference/warehouse-types",
  validate: "/api/shipping/reference/validate",
  health: "/api/shipping/reference/health",
} as const;
